import { h, Component } from 'preact'

import Map from '@components/Map'
import StationSlider from '@components/StationSlider'
import TabBar from '@shared/components/TabBar'
import icon404 from './icon404.svg'
import _ from './styles.sass'

// ready, set, GO!
export default class VisualisationContainer extends Component {
  handleViewSelectorChange = ({ selectedValue }) => {
    if (selectedValue === 'map') {
      this.context.actions.deselectMarker()
    } else {
      this.context.actions.selectMarker({ byIndex: 0 })
    }
  }

  render (props) {
    const { markers, selectedMarkerIndex } = this.props
    const selectedMarker = (markers || [])[selectedMarkerIndex]
    const hasMarker = selectedMarker !== undefined

    const brandenburgImage = <svg xmlns='http://www.w3.org/2000/svg' width='21' height='22' viewBox='0 0 42 44'><path fill={hasMarker ? '#585856' : 'white'} fill-rule='evenodd' d='M41 39v1h-1v-1 1h-1-2v1-1h-1-1v1h-1v1-1l-1 1h1v1h-1v1-1h-1v1h-1v-1 1h-1-1v-1 1h-1v-1h-1v1-1l-1-1h-1l-1 1h-1v-1c0 1 0 0 0 0v-2h-1v-1l-1-1h2l-1-1h1l-1-1h1-1 1v-1h-1v-1h-1v-1h-2v-1h-2v-1h-1v1h-1v-1h-2v-1h-1v-1h-1v-1-1h1l-1-1 1-1v-4 1-1h-2 1-1v-1h1v-4l1-1h-1v-1H8v-1H7v-1H6v-1l-1 1v-1H4v-1 1-1H0V9h4L3 8h1V7H3h4L6 6h3V4h1v1-1h1v1-1l1 1h2v1h-1 4v1h1v1l1-1v1-1 1h1V7v1-1h1l-1 1h1l1-1V6h1v1h1V6h2V5h1V3h1V2h1V1l1 1V0v1h1v1h1-1v1h1V2h1v1h1V2l1 1V2v1h1-1v2h-1v1h2V5h2v2h-1v3l-1 1-1 1v2h-1v1h2v1h1v1h1v1h1v1h1v3h-1v2h1v2h1v3h1v2h-1 1-1v3h-1v1h1v2h1v2h-1z' /></svg>

    const stationsImage = <svg width='12px' height='16px' viewBox='-10 0 288 352' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <path fill={hasMarker ? 'white' : '#585856'} d='M101.003681,274.201165 C94.763682,259.74013 80.7989308,256.219867 73.9452637,252.761886 C30.3788436,230.78068 0.5,185.629629 0.5,133.5 C0.5,59.7699859 60.2699859,0 134,0 C208.230014,0 268,59.7699859 268,133.5 C268,185.629629 238.121156,230.78068 194.554736,252.761886 C187.701069,256.219867 173.736318,259.74013 167.496319,274.201165 L134.294922,351.144531 C134.254994,351.049158 123.157914,325.401369 101.003681,274.201165 Z' />
    </svg>

    const viewSelectorProps = {
      id: 'viewSelector',
      class: _.tabBar,
      title: 'Ansicht Auswählen',
      selectedValue: hasMarker ? 'station' : 'map',
      options: [
        { value: 'map', display: <span class={_.tabBarContent}>{brandenburgImage} Karte</span> },
        { value: 'station', display: <span class={_.tabBarContent}>{stationsImage} Messpunkte</span> }
      ],
      onChange: this.handleViewSelectorChange
    }

    const title = <div class={_.titleWrapper}>
      <h3 class={_.title}>Stickstoffdioxid-Monitor</h3>
    </div>

    if (markers == null) {
      return <div class={_.app}>{title}<p class={_.loading}>wird geladen…</p></div>
    }

    if (markers.length === 0) {
      return <div class={_.app}>
        {title}
        <div class={_.noDataError}>
          <img src={icon404} alt='Fehler' />
          Leider können wir momentan keine Daten anzeigen. Kommen Sie bitte später wieder.
        </div>
      </div>
    }

    return <div class={_.app}>
      {title}
      <Map class={`${_.map} ${hasMarker && _.isHidden}`} {...props} />
      { hasMarker && <StationSlider class={_.station} {...props} /> }
      <TabBar {...viewSelectorProps} />
    </div>
  }
}
